import { Box, Stack } from "@mui/material";
import type { FC } from "react";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { HoverBadge } from "../hover-badge";
import { HeaderTextPreview } from "./header-text-preview";
import { LogoPreview } from "./logo-preview";
import type { PreviewProps } from "./types";

export const HeaderPreview: FC<PreviewProps> = (props) => {
  const { header, layout_settings } = props.data;

  return (
    <ConditionalWrapper
      condition={props.badgeProps !== undefined}
      wrapper={(children) => (
        <HoverBadge badgeContent="Header" name="header" {...props.badgeProps}>
          {children}
        </HoverBadge>
      )}
    >
      <Box
        sx={{
          bgcolor: header?.fullWidth ? header?.backgroundColor : undefined,
        }}
      >
        <Box
          sx={{
            bgcolor: header?.backgroundColor,
            width: "100%",
            maxWidth: `${layout_settings?.max_paper_width}px`,
            margin: "0 auto",
            height: header?.logo || header?.text ? "auto" : "80px",
            ...(header
              ? {
                  paddingRight: `${header.paper_padding_side}px`,
                  paddingLeft: `${header.paper_padding_side}px`,
                  paddingTop: `${header.paper_padding_top}px`,
                  paddingBottom: `${header.paper_padding_bottom}px`,
                }
              : {
                  paddingRight: 0,
                  paddingLeft: 0,
                  paddingTop: 0,
                  paddingBottom: 0,
                }),
          }}
        >
          <Stack direction="column" sx={{ width: "100%" }}>
            {header?.logo && <LogoPreview {...props} />}
            {header?.text && <HeaderTextPreview {...props} />}
          </Stack>
        </Box>
      </Box>
    </ConditionalWrapper>
  );
};
